export default class backToTop {
  constructor() {
    this.backToTop = document.querySelector('.back-to-top');
    this.backToTop.addEventListener('click', e => this.scrollToTop(e));
    this.pinButtonTop();
  }

  scrollToTop(e) {
    e.preventDefault();
    const button = e.target.closest('.back-to-top');
    $('html, body').animate({
      scrollTop: 0,
    }, 600);
    button.blur();
  }

  pinButtonTop() {
    const $button = $('.button-sticky-top');
    const pageOffset = 600;

    $(window).on('scroll', () => {
      if ($(window).scrollTop() >= pageOffset) {
        $button.addClass('visible-button');
      } else {
        $button.removeClass('visible-button');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/backToTop.js